import "./notificationBox.css"

export function NotificationBox({ notification, notificationPopup }) {
    return (
        <div
            className={`notification-popup py-3 px-4 bg-white rounded-1 d-flex
            ${notificationPopup ? "on" : ""}`}
            onClick={(e) => e.preventDefault()}>

            <div className="d-flex justify-content-center gap-4 mx-auto">

                {
                    notification.type.includes("ERROR") ?
                    <div className="error-icon"></div>
                    :
                    <div className="success-icon"></div>
                }
            
                <div className="notification-message text-center">
                    {
                        notification.type === "ADD_TO_WISHLIST" ?
                        "Item added to your wishlist"
                            : notification.type === "ADD_TO_CART" ?
                            "Item added to cart"
                            : notification.type === "UPDATE_CART_ITEM" ?
                            "Cart Item updated"
                            : notification.type === "UPDATE_CART" ?
                            "Cart updated"
                            : notification.type === "UPDATE_PROFILE" ?
                            "Profile changes saved"
                            : notification.type === "ADD_PRODUCT" ?
                            "New product added"
                            : notification.type === "UPDATE_PRODUCT" ?
                            "Product updated"
                            : notification.type === "DELETE_PRODUCT" ?
                            "Product deleted"
                            : notification.type === "PLACE_ORDER" ?
                            "Order placed"
                            : notification.type === "UPDATE_ORDER" ?
                            "Order status updated"
                            : notification.type.includes("ACTION_FORBIDDEN") ?
                            "Action Forbidden"
                            : 
                            ""
                        }
                </div>
            
            </div>
            
        </div>
    )
}